import _ from 'lodash';
import TemplateCard, { TemplateCardProps } from '../TemplateCard';
import TemplateCardMobile from '../TemplateCardMobile';

interface Props extends TemplateCardProps {
  isMobileView: boolean;
}

const TemplateCardAdaptive = (props: Props) => {
  if (props.isMobileView) {
    return <TemplateCardMobile {...props} />;
  }

  return <TemplateCard {...props} />;
};

export default TemplateCardAdaptive;
